import React from 'react';
import { connect } from 'react-redux';
import TransactionRow from './TransactionRow';

const mapStateToProps = (state) => {
  return {
    transactions: state.transactions
  };
};

const connectedLatestTransactions = ({transactions}) => (
  <div className="c-component c-transactions">
    <h2>Latest Transactions</h2>
    <ul className="c-transactions__list">
      {transactions
        .reverse()
        .slice(0, 10)
        .map((transactionEvent) => (
          <li key={transactionEvent.transactionHash} className="c-transactions__list-item">
            <TransactionRow transaction={transactionEvent}/>
          </li>
        ))}
    </ul>
  </div>
);

const LatestTransactions = connect(mapStateToProps)(connectedLatestTransactions);

export default LatestTransactions;



// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/LatestTransactions.js